<template>
  <div @keyup.enter="enterSearch">
    <el-form :model="form" ref="form" class="table-search-bar" inline label-width="70px">
      <el-form-item label="客户类型" prop="custType">
        <el-select v-model="form.custType">
          <el-option v-for="item in custTypeOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="终端客户等级" prop="custLevel">
        <el-select v-model="form.custLevel">
          <el-option v-for="item in custLevelOptions"
            :key="item.label"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="custName">
        <el-input v-model="form.custName" clearable placeholder="请输入客户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <!-- <el-button type="primary" @click="handleAdd">新增</el-button> -->
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        prop="custName"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="custType"
        label="客户类型"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="custLevel"
        label="终端客户等级"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            @click="handleCheck(scope.$index, scope.row)">查看</el-button>
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <el-row class="export-row" type="flex" justify="end" v-permission="'0171401'">
      <el-col :span="4">
        每页
        <el-select class="width100" v-model="exportForm.pageSize" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        条
      </el-col>
      <el-col :span="4">
        第
        <el-select class="width100" v-model="exportForm.pageNo">
          <el-option v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="handleExport">导出为CSV文件</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'StatisticalReportSalePlanCustom',
  data () {
    return {
      form: {
        custType: '',
        custLevel: '',
        custName: ''
      },
      exportForm: {
        pageSize: 1000,
        pageNo: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ],
      custTypeOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '终端',
          value: '终端'
        },
        {
          label: '预留',
          value: '预留'
        },
        {
          label: '贸易',
          value: '贸易'
        },
        {
          label: '分销',
          value: '分销'
        }
      ],
      custLevelOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: 'A',
          value: 'A'
        },
        {
          label: 'B',
          value: 'B'
        },
        {
          label: 'C',
          value: 'C'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      list: 'getStatisticalReportSalePlanCustomList',
      listState: 'getStatisticalReportSalePlanCustomListState'
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getStatisticalReportSalePlanCustomList', 'getStatisticalReportSalePlanCustomDetail', 'delStatisticalReportSalePlanCustom', 'exportStatisticalReportSalePlanCustom']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSizeChange (val) {
      this.getStatisticalReportSalePlanCustomList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getStatisticalReportSalePlanCustomList({ pageNo: val })
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getStatisticalReportSalePlanCustomList(params)
    },
    handleAdd () {
      // 打开新增页面
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleCheck (index, row) {
      // 打开查看界面
    },
    handleEdit (index, row) {
      // 打开编辑界面
    },
    handleDelete (index, row) {
      this.$confirm('确定删除？', '删除提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除接口
        this.delStatisticalReportSalePlanCustom({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.handleSearch()
        })
      }).catch(() => {
        // 取消删除
      })
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.pageNo = 1
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportStatisticalReportSalePlanCustom({ ...this.form, ...this.exportForm }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '销售计划客户.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
